import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { montpelierConfig } from "./data";

export default function MontpelierPage() {
  return <CityPageTemplate config={montpelierConfig} />;
}